import { Controller } from "@hotwired/stimulus"
import { changeProductSelection } from "../selection/product-selection-api"

export default class extends Controller {
  static values = {
    size: Number,
    imperialSize: String,
    metricSize: String
  }

  select(event) {
    event?.preventDefault()
    
    const stateElement = document.getElementById('product-selection-state')
    if (!stateElement) {
      console.error('Product selection state element not found')
      return
    }

    changeProductSelection(this.element, stateElement)
  }

  markAsSelected() {
    this.element.classList.remove('unselected')
    this.element.classList.add('selected')
    this.element.setAttribute('aria-pressed', 'true')
  }

  markAsUnselected() {
    this.element.classList.remove('selected')
    this.element.classList.add('unselected')
    this.element.setAttribute('aria-pressed', 'false')
  }

  updateSelection(selectedSize) {
    if (parseFloat(this.sizeValue) === parseFloat(selectedSize)) {
      this.markAsSelected()
    } else {
      this.markAsUnselected()
    }
  }
}
